module.exports = __webpack_public_path__ + "img/logo_white.35f282ec.webp";